import { ArrowRightIcon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import Breadcrumbs from '../../components/Breadcrumbs';
import { PageTitle } from '../../components/PageTitle';
import { Pane } from '../../components/Pane';
import { GithubLink } from './GithubLink';
import PythonLogo from './PythonLogo';
import TypeScriptLogo from './TypeScriptLogo';

interface Template {
  id: string;
  created_at: string;
  github_url: string;
  name: string;
  description: string;
  language: string;
}

function fetchTemplates(): Template[] {
  return [
    {
      id: '38d95bea-7d95-4626-a956-8936e98d1c9f',
      created_at: '2024-10-07 15:54:29.85924+00',
      github_url: 'https://github.com/langchain-ai/memory-agent-js',
      name: 'LangGraph.js Memory Agent',
      description:
        'Build a memory agent that saves memories about the user with a tool call. Memory management is done in the "hot-path", meaning your agent or chatbot must decide to save memories in addition to chatting or doing other work.',
      language: 'javascript',
    },
    {
      id: '705e0edc-714e-4b01-b9fb-a7589e6684b0',
      created_at: '2024-12-03 14:46:35.451523+00',
      github_url: 'https://github.com/langchain-ai/rag-research-agent-template',
      name: 'LangGraph RAG Research Agent Template',
      description:
        'This LangGraph template implements a RAG research agent that creates a research plan to answer a question and conducts research using a retriever.',
      language: 'python',
    },
    {
      id: 'f887e836-538e-48ae-8a68-a6e9a2a2bbdb',
      created_at: '2024-12-03 14:47:50.315571+00',
      github_url:
        'https://github.com/langchain-ai/rag-research-agent-template-js',
      name: 'LangGraph.js RAG Research Agent Template',
      description:
        'This LangGraph template implements a RAG research agent that creates a research plan to answer a question and conducts research using a retriever.',
      language: 'javascript',
    },
    {
      id: '24e2ef6e-1b87-42b6-acf6-2a84f95bf0bc',
      created_at: '2024-09-12 20:36:59.244236+00',
      github_url: 'https://github.com/langchain-ai/react-agent',
      name: 'LangGraph ReAct Agent Template',
      description: 'LangGraph template for a simple ReAct agent',
      language: 'python',
    },
    {
      id: '3ef33639-a229-4586-b63e-a13a8fce57e0',
      created_at: '2024-09-17 15:38:02.054198+00',
      github_url: 'https://github.com/langchain-ai/new-langgraph-project',
      name: 'New LangGraph Project',
      description:
        'This template demonstrates a simple chatbot implemented using LangGraph, designed for LangGraph Studio. The chatbot maintains persistent chat memory, allowing for coherent conversations across multiple interactions.',
      language: 'python',
    },
    {
      id: '7882888f-0bc7-4a59-9c07-98ed68a4726f',
      created_at: '2024-09-12 20:37:57.457298+00',
      github_url: 'https://github.com/langchain-ai/data-enrichment',
      name: 'LangGraph Data Enrichment Template',
      description:
        'This is a starter project to help you get started with developing a data enrichment agent using LangGraph in LangGraph Studio.',
      language: 'python',
    },
    {
      id: '71dce32c-526d-4173-8220-2c2badc33955',
      created_at: '2024-09-11 13:10:24.295378+00',
      github_url: 'https://github.com/langchain-ai/retrieval-agent-template',
      name: 'LangGraph Retrieval Agent Template',
      description:
        'This LangGraph template implements a simple, extensible agent that answers questions based on a retriever.',
      language: 'python',
    },
    {
      id: '5d887234-e559-4ff9-b955-1cfc40fdb1f4',
      created_at: '2024-09-12 20:37:32.824806+00',
      github_url: 'https://github.com/langchain-ai/data-enrichment-js',
      name: 'LangGraph.js Data Enrichment Template',
      description:
        'This is a starter project to help you get started with developing a data enrichment agent using LangGraph.js in LangGraph Studio.',
      language: 'javascript',
    },
    {
      id: '894752c8-e9e8-4f95-8fa3-e962be31cbab',
      created_at: '2024-09-12 20:38:42.347668+00',
      github_url: 'https://github.com/langchain-ai/retrieval-agent-template-js',
      name: 'LangGraph.js Retrieval Agent Template',
      description:
        'This repo offers the basic code structure to get started building LangGraph workflows in JavaScript within LangGraph studio.',
      language: 'javascript',
    },
    {
      id: 'a9177518-8a52-4085-a4ea-892538ca0070',
      created_at: '2024-09-12 20:33:13.447405+00',
      github_url: 'https://github.com/langchain-ai/react-agent-js',
      name: 'LangGraph.js ReAct Agent Template',
      description:
        'This LangGraph template implements a simple, extensible agent that answers questions based on a retriever.',
      language: 'javascript',
    },
    {
      id: 'a57e04c4-1ed6-485b-9e55-84b8094dca1b',
      created_at: '2024-09-17 15:38:37.083884+00',
      github_url: 'https://github.com/langchain-ai/new-langgraphjs-project',
      name: 'New LangGraph.js Project',
      description:
        'This is a (mostly empty) starter project to help you get started with developing LangGraph.js projects in LangGraph Studio.',
      language: 'javascript',
    },
    {
      id: '96c9ce66-de7d-4625-ac0b-dc55d9314770',
      created_at: '2024-10-07 15:53:49.746799+00',
      github_url: 'https://github.com/langchain-ai/memory-agent',
      name: 'LangGraph Memory Agent',
      description:
        'Build a memory agent that saves memories about the user with a tool call. Memory management is done in the "hot-path", meaning your agent or chatbot must decide to save memories in addition to chatting or doing other work.',
      language: 'python',
    },
  ];
}

export default function HostNew() {
  const templates = fetchTemplates();
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="px-4 pb-6 pt-3">
        <Breadcrumbs />
        <div className="my-4 flex items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <PageTitle
              className="py-0"
              description="Get started from a template, or design your custom architecture"
            >
              Create a new Agent
            </PageTitle>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <main className="flex flex-col items-center gap-16 px-8">
            <div className="mt-8 flex flex-col gap-6">
              <div className="flex flex-col items-center text-center text-tertiary">
                <div className="mb-4 text-xl">Design your agent</div>
                <div className="grid max-w-[800px] grid-cols-1 gap-4 lg:grid-cols-[repeat(auto-fit,minmax(300px,1fr))]">
                  <div className="group flex flex-col gap-2 rounded-lg border border-secondary p-4 text-left transition-all">
                    <div className="flex items-end gap-4">
                      <p className="mb-1 font-semibold">Create a new Agent</p>
                    </div>

                    <p className="text-sm text-tertiary">
                      Quickly prototype your agent's architecture with no code
                    </p>

                    <div className="flex-grow" />

                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => setOpen(true)}
                        className="inline-flex items-center gap-2 self-start rounded-full border border-current px-3 py-1 text-sm text-brand-primary transition-colors hover:bg-brand-primary-hover"
                      >
                        <span>Open</span>
                        <ArrowRightIcon className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 flex flex-col gap-6">
              <div className="flex flex-col items-center text-center text-tertiary">
                <div className="text-xl">Get started from a template</div>
              </div>
              <div className="grid max-w-[800px] grid-cols-1 gap-4 lg:grid-cols-[repeat(auto-fit,minmax(300px,1fr))]">
                {templates.map((project, idx) => (
                  <a
                    href={`langgraph:///template?githubUrl=${encodeURIComponent(
                      project.github_url
                    )}`}
                    key={idx}
                    type="button"
                    className="group flex flex-col gap-2 rounded-lg border border-secondary p-4 text-left transition-all hover:bg-secondary active:bg-secondary"
                  >
                    <span className="grid grid-cols-[1fr,auto] gap-2">
                      <span className="font-medium">{project.name}</span>
                      {project.language === 'javascript' ? (
                        <TypeScriptLogo
                          className="h-6 w-6"
                          viewBox="0 0 256 256"
                        />
                      ) : project.language === 'python' ? (
                        <PythonLogo className="h-6 w-6" viewBox="0 0 100 100" />
                      ) : null}
                    </span>

                    <span className="flex-grow text-sm">
                      {project.description}
                    </span>
                    <GithubLink link={project.github_url} />
                  </a>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
      <Pane
        open={open}
        onClose={() => setOpen(false)}
        title="Create a new Agent"
      >
        <iframe
          src="https://build.langchain.com/"
          className="-mx-16 -mb-16 -mt-6 h-[calc(100%+5.5rem)] w-[calc(100%+8rem)]"
        />
      </Pane>
    </>
  );
}
